import { ThemeConfig } from 'antd';

export const customDefaultTheme: ThemeConfig = {
  token: {
    colorPrimary: '#5C48F6',
  },
  components: {
    Tree: {
      nodeSelectedBg: '#112545',
    },
  },
};
